import React from "react"
import { Link } from "gatsby"
import { SwapRightOutlined, PhoneOutlined } from "@ant-design/icons"
import styled from "@emotion/styled"

const StyleWrapper = styled(Link)`
  min-width: 160px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-family: "Prompt", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  background-color: #fc1a58;
  border: 2px solid #fc1a58;
  border-radius: 25.5px;
  text-decoration: none;
  transition: all 0.25s ease-in-out;
  &:hover {
    color: #fff;
    background-color: #221638;
    border: 2px solid #221638;
    text-decoration: none;
  }
  img {
    margin-left: 35px;
    margin-bottom: 0;
    max-height: 15px;
  }
`
const LinkWrapper = styled.a`
  min-width: 142px;
  height: auto;
  width: 100%;
  max-width: 333px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  font-family: "Prompt", sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #fff;
  background-color: #00c300;
  border: 2px solid #00c300;
  border-radius: 6px;
  text-align: left;
  text-decoration: none;
  transition: all 0.25s ease-in-out;
  &:hover {
    color: #fff;
    background-color: #221638;
    border: 2px solid #221638;
    text-decoration: none;
  }
  .anticon {
    font-size: 24px;
    margin-right: 5px;
  }
  p {
    margin-bottom: 0em;
    span {
      color: #fff500;
    }
  }

  @media only screen and (min-width: 576px) {
    height: 110px;
    width: 350px;
    max-width: 350px;
    font-size: 22px;
  }
  @media only screen and (max-width: 320px) {
    max-width: 100%;
    font-size: 16px;
  }
`
const LinkPhoneWrapper = styled.a`
  min-width: 142px;
  height: 80px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-family: "Prompt", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #fff;
  background-color: #eb3658;
  border: 2px solid #eb3658;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.25s ease-in-out;
  &:hover {
    color: #fff;
    background-color: #221638;
    border: 2px solid #221638;
    text-decoration: none;
  }
  .anticon {
    font-size: 24px;
    margin-right: 5px;
  }
`

const ButtonRegister = ({ text, click, subtext, cta, path, icon }) => {
  if (path && path !== "undefined") {
    if (icon === "phone") {
      return (
        <LinkPhoneWrapper href={cta} target="_blank" rel="noreferrer">
          <PhoneOutlined />
          {text}
          <br />
          {subtext}
        </LinkPhoneWrapper>
      )
    } else {
      return (
        <LinkWrapper href={cta} target="_blank" rel="noreferrer">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 16 16"
            height="3rem"
            width="3rem"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0M5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.15.15 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157m.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832l-.013-.015v-.001l-.01-.01-.003-.003-.011-.009h-.001L7.88 4.79l-.003-.002-.005-.003-.008-.005h-.002l-.003-.002-.01-.004-.004-.002-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.2.2 0 0 0 .039.038l.001.001.01.006.004.002.008.004.007.003.005.002.01.003h.003a.2.2 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.16.16 0 0 0-.108.044h-.001l-.001.002-.002.003a.16.16 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.16.16 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"></path>
          </svg>
          <p>
            {text} <span>{click}</span>
            <br />
            {subtext}
          </p>
        </LinkWrapper>
      )
    }
  }
  return (
    <StyleWrapper to={cta}>
      <SwapRightOutlined />
      {text}
      <br />
      {subtext}
    </StyleWrapper>
  )
}

export default ButtonRegister
